var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "类别",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-tree-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      dropdownStyle: {
                                        maxHeight: "200px",
                                        overflow: "auto",
                                      },
                                      "allow-clear": "",
                                      treeData: _vm.categoryTree,
                                      placeholder: "请选择类别",
                                    },
                                    model: {
                                      value: _vm.queryParam.categoryId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "categoryId",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.categoryId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "关键词",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder:
                                        "请输入条码、名称、助记码等查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.materialParam,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "materialParam",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.materialParam",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "规格",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入规格查询" },
                                    model: {
                                      value: _vm.queryParam.standard,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "standard",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.standard",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.handleToggleSearch },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.toggleSearchStatus
                                              ? "收起"
                                              : "展开"
                                          ) +
                                          "\n                  "
                                      ),
                                      _c("a-icon", {
                                        attrs: {
                                          type: _vm.toggleSearchStatus
                                            ? "up"
                                            : "down",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.toggleSearchStatus
                        ? [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "型号",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入型号查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.model,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "model",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.model",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "颜色",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入颜色查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.color,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "color",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.color",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "品牌",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入品牌查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.brand,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "brand",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.brand",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "制造商",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入制造商查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.mfrs,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "mfrs",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.mfrs",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: _vm.queryTitle.mp1,
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder:
                                              "请输入" +
                                              _vm.queryTitle.mp1 +
                                              "查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.otherField1,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "otherField1",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryParam.otherField1",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: _vm.queryTitle.mp2,
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder:
                                              "请输入" +
                                              _vm.queryTitle.mp2 +
                                              "查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.otherField2,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "otherField2",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryParam.otherField2",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: _vm.queryTitle.mp3,
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder:
                                              "请输入" +
                                              _vm.queryTitle.mp3 +
                                              "查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.otherField3,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "otherField3",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryParam.otherField3",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "状态",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择状态",
                                            },
                                            model: {
                                              value: _vm.queryParam.enabled,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "enabled",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.enabled",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "1" } },
                                              [_vm._v("启用")]
                                            ),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("禁用")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "序列号",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "有无序列号",
                                            },
                                            model: {
                                              value:
                                                _vm.queryParam
                                                  .enableSerialNumber,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "enableSerialNumber",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryParam.enableSerialNumber",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "1" } },
                                              [_vm._v("有")]
                                            ),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("无")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "批号",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: { placeholder: "有无批号" },
                                            model: {
                                              value:
                                                _vm.queryParam
                                                  .enableBatchNumber,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "enableBatchNumber",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryParam.enableBatchNumber",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "1" } },
                                              [_vm._v("有")]
                                            ),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("无")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "仓位货架",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: "请输入仓位货架查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.position,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "position",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.position",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "基础重量",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: "请输入基础重量查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.weight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "weight",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.weight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "保质期",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: "请输入保质期查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.expiryNum,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "expiryNum",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.expiryNum",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "备注",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入备注查询",
                                          },
                                          model: {
                                            value: _vm.queryParam.remark,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "remark",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.remark",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "delete" },
                          on: { click: _vm.batchDel },
                        },
                        [_vm._v("删除")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "check-square" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(true)
                            },
                          },
                        },
                        [_vm._v("启用")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "close-square" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(false)
                            },
                          },
                        },
                        [_vm._v("禁用")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "import" },
                          on: {
                            click: function ($event) {
                              return _vm.handleImportXls()
                            },
                          },
                        },
                        [_vm._v("导入")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(3) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "download" },
                          on: {
                            click: function ($event) {
                              return _vm.handleExportXls("商品信息")
                            },
                          },
                        },
                        [_vm._v("导出")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "edit" },
                          on: {
                            click: function ($event) {
                              return _vm.batchEdit()
                            },
                          },
                        },
                        [_vm._v("批量编辑")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "stock" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetMaterialCurrentStock()
                            },
                          },
                        },
                        [_vm._v("修正库存")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "fund" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetMaterialCurrentUnitPrice()
                            },
                          },
                        },
                        [_vm._v("修正成本")]
                      )
                    : _vm._e(),
                  _c(
                    "a-popover",
                    { attrs: { trigger: "click", placement: "right" } },
                    [
                      _c(
                        "template",
                        { slot: "content" },
                        [
                          _c(
                            "a-checkbox-group",
                            {
                              attrs: { defaultValue: _vm.settingDataIndex },
                              on: { change: _vm.onColChange },
                              model: {
                                value: _vm.settingDataIndex,
                                callback: function ($$v) {
                                  _vm.settingDataIndex = $$v
                                },
                                expression: "settingDataIndex",
                              },
                            },
                            [
                              _c(
                                "a-row",
                                { staticStyle: { width: "500px" } },
                                [
                                  _vm._l(
                                    _vm.defColumns,
                                    function (item, index) {
                                      return [
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { span: 8 } },
                                            [
                                              _c(
                                                "a-checkbox",
                                                {
                                                  attrs: {
                                                    value: item.dataIndex,
                                                  },
                                                },
                                                [
                                                  _c("j-ellipsis", {
                                                    attrs: {
                                                      value: item.title,
                                                      length: 10,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "a-row",
                                { staticStyle: { "padding-top": "10px" } },
                                [
                                  _c(
                                    "a-col",
                                    [
                                      _vm._v(
                                        "\n                  恢复默认列配置："
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          attrs: {
                                            type: "link",
                                            size: "small",
                                          },
                                          on: { click: _vm.handleRestDefault },
                                        },
                                        [_vm._v("恢复默认")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-button", { attrs: { icon: "setting" } }, [
                        _vm._v("列设置"),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      components: _vm.handleDrag(_vm.columns),
                      pagination: _vm.ipagination,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                      rowSelection: {
                        selectedRowKeys: _vm.selectedRowKeys,
                        onChange: _vm.onSelectChange,
                        columnWidth: "40px",
                      },
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(record)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleCopyAdd(record)
                                        },
                                      },
                                    },
                                    [_vm._v("复制")]
                                  )
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleGoodsDisplay(record)
                                        },
                                      },
                                    },
                                    [_vm._v("商城展示")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        },
                      },
                      {
                        key: "customPic",
                        fn: function (text, record) {
                          return [
                            _c(
                              "a-popover",
                              {
                                attrs: { placement: "right", trigger: "click" },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.getImgUrl(
                                        record.imgName,
                                        record.imgLarge
                                      ),
                                      width: "500px",
                                    },
                                  }),
                                ]),
                                record.imgName
                                  ? _c("div", { staticClass: "item-info" }, [
                                      record.imgName
                                        ? _c("img", {
                                            staticClass: "item-img",
                                            attrs: {
                                              src: _vm.getImgUrl(
                                                record.imgName,
                                                record.imgSmall
                                              ),
                                              title: "查看大图",
                                            },
                                          })
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        },
                      },
                      {
                        key: "customBarCode",
                        fn: function (text, record) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(record.mBarCode) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "customName",
                        fn: function (text, record) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(record.name) +
                                "\n            "
                            ),
                            record.enableSerialNumber == 1
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("序"),
                                ])
                              : _vm._e(),
                            record.enableBatchNumber == 1
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("批"),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "customRenderInitialStock",
                        fn: function (text, record) {
                          return [
                            _c(
                              "a-tooltip",
                              { attrs: { title: record.bigUnitInitialStock } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(text) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "customRenderStock",
                        fn: function (text, record) {
                          return [
                            _c(
                              "a-tooltip",
                              { attrs: { title: record.bigUnitStock } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(text) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "customRenderEnabled",
                        fn: function (enabled) {
                          return [
                            enabled
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("启用"),
                                ])
                              : _vm._e(),
                            !enabled
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("禁用"),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("material-modal", {
                ref: "modalForm",
                on: { ok: _vm.modalFormOk },
              }),
              _c("import-file-modal", {
                ref: "modalImportForm",
                on: { ok: _vm.modalFormOk },
              }),
              _c("batch-set-info-modal", {
                ref: "batchSetInfoModalForm",
                on: { ok: _vm.modalFormOk },
              }),
              _c("goods-display-setting", { ref: "goodsDisplayForm" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }